import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { gridSize } from '@atlaskit/theme/constants';
export var PaginationDetailsStyled = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: 1;\n  text-align: right;\n  margin: ", "px ", "px;\n  font-size: ", "px;\n  color: #979797;\n"])), gridSize() * 1.25, gridSize() * 1.875, gridSize() * 1.75);